// extracted by mini-css-extract-plugin
export var amountInput = "styles-module--amountInput--7961e";
export var or = "styles-module--or--18546";
export var percentInput = "styles-module--percentInput--da295";
export var percentVal = "styles-module--percentVal--36bd1";
export var residualWrapper = "styles-module--residualWrapper--e7458";
export var wrapper = "styles-module--wrapper--b73cc";